import { combineReducers } from 'redux';
import { FooterDefinition } from '@pegasus/ui-footers';

import { defineFetchForNamespace } from 'src/client/components/shared/redux/fetch';
import { fetchFooter } from 'src/client/api/services/footer';

export const NAME = 'fetch';
export const NAMESPACE = 'footer';

const { reducer, getIsInitial, getIsLoading, getData, fetchData } = defineFetchForNamespace<
    FooterDefinition,
    string | undefined,
    typeof NAMESPACE,
    typeof NAME
>(NAMESPACE, NAME, (locale: string) => fetchFooter(locale).then(response => response.results));

const getFooterReducer = () => ({
    [NAMESPACE]: combineReducers({
        [NAME]: reducer,
    }),
});

export {
    getFooterReducer,
    getIsInitial,
    getIsLoading,
    getData as getFooter,
    fetchData as fetchFooter,
};
